import React from 'react';
import { Row, Col, Layout } from 'antd';

import LoginForm from '../components/login';

const { Content, Footer } = Layout;

const LoginPage = () => {
	return (
		<Layout style={{height: "100vh"}} className="layout">

			<Content className="layout-column layout-align-center-y" style={{ padding: '50px 0px' }}>
				<Row 
					type="flex" 
					align="middle">
					<Col offset={8} span={8}>
						<LoginForm />
					</Col>
				</Row>
				
			</Content>

			<Footer style={{ textAlign: 'center' }}>
				Eezee Pte Ltd
			</Footer>
		</Layout>
	)
}

export default LoginPage;


// WEBPACK FOOTER //
// ./src/containers/login-page.js